module.exports = __webpack_public_path__ + "media/Chapter2AudioLoop.9ace1b08.mp3";